import { Section, SectionHeader, SectionTitle } from "@/blocks/Section";

export function PlaygroundSectionTalkRatio() {
  return (
    <Section data-test="talk-ratio-section">
      <SectionHeader>
        <SectionTitle>Talk ratio</SectionTitle>
      </SectionHeader>
      <div className="flex w-full flex-col gap-1">
        <div className="flex items-center gap-2">
          <span className="text-sm text-foreground">Agent</span>
          <span className="text-sm text-muted-foreground">62%</span>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-sm text-foreground">Customer</span>
          <span className="text-sm text-muted-foreground">38%</span>
        </div>
      </div>
    </Section>
  );
}
